module.exports = __webpack_public_path__ + "media/images/icon__externalLink-5fee0d4a26366cf54c9a403fcf0273e0.png";